/**
 * revenueCounters — placeholder data structure for the Admin Dashboard
 * → Revenue Overview section.
 *
 * Client-only until Phase 9 (Stripe billing). This shape is what the
 * `<RevenueOverview />` UI reads; Phase 9 will replace the export with
 * a `useRevenueCounters()` hook that fetches from the Stripe-backed
 * endpoint — no UI change required.
 *
 * Keys:
 *   basicPurchases     — one-off unlock count (Stripe `payment_intents`)
 *   premiumSubscribers — active recurring subscribers (Stripe `subscriptions`)
 */
export const revenueCounters = {
  basicPurchases: 0,
  premiumSubscribers: 0,
};

/** Convenience getter so future data sources (hook, context, API) can
 * swap in without changing the consumer. */
export function getRevenueCounters() {
  return revenueCounters;
}
